import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Modal,
  Button,
  Table,
  Badge,
} from "react-bootstrap";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { testmenuCreateAgency } from "../../api/testMenuService";

function MyPage() {
  const navigate = useNavigate();
  const [agencyDetails, setAgencyDetails] = useState({
    agencyName: "",
    phoneNumber: "",
    // yg bawah ni data hardcode, kalau takda kemungkinan error
    sectorId: "PS-ES",
    address1: "123",
    address2: "123",
    address3: "123",
    poscode: "123",
    city: "1600",
    state: "16",
    country: "MAS",
    cpdName: "test",
    cpdEmail: "test@email",
    cpdPhoneNumber: "123",
    loginId: "test@email",
    status: "DRAFT",
    manualSubmission: false,
    installedCapacity: false,
    powerPlantPerformance: false,
    netCalorificValue: false,
    c1CheckBox: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAgencyDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await testmenuCreateAgency(agencyDetails);
      alert("Agency created successfully");
      navigate("/testmenu/list");
    } catch (error) {
      alert("Error Update agency");
    }
  };

  return (
    <Card className="mt-4">
      <Card.Body>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col sm={6}>
              <Form.Label>
                <strong>AGENCY NAME</strong>
              </Form.Label>
              <Form.Control
                type="text"
                name="agencyName"
                value={agencyDetails.agencyName}
                onChange={handleChange}
                required
              />
            </Col>
            <Col sm={6}>
              <Form.Label>
                <strong>AGENCY PHONE NUMBER</strong>
              </Form.Label>
              <Form.Control
                type="text"
                name="phoneNumber"
                value={agencyDetails.phoneNumber}
                onChange={handleChange}
                required
              />
            </Col>
          </Row>
          <Button type="submit" variant="primary">
            Save
          </Button>
        </Form>
      </Card.Body>
    </Card>
  );
}

export default MyPage;
